/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "igniteui-react-core";
import { IPlatformPixelConverter_$type } from "./IPlatformPixelConverter";
/**
 * @hidden
 */
var DefaultPlatformPixelConverter = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(DefaultPlatformPixelConverter, _super);
    function DefaultPlatformPixelConverter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DefaultPlatformPixelConverter.prototype.devicePixelsToPixel = function (a) {
        return a;
    };
    DefaultPlatformPixelConverter.$t = markType(DefaultPlatformPixelConverter, 'DefaultPlatformPixelConverter', Base.$, [IPlatformPixelConverter_$type]);
    return DefaultPlatformPixelConverter;
}(Base));
export { DefaultPlatformPixelConverter };
//# sourceMappingURL=DefaultPlatformPixelConverter.js.map
